export async function fetchGraduationYears(apiInstance) {
  try {
    const response = await apiInstance.get(`/LeaderBoard/graduation-years`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error fetching results");
  }
}

export async function fetchPublicEvents(apiInstance) {
  try {
    const response = await apiInstance.get(`/LeaderBoard/search-event`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error fetching results");
  }
}

export async function fetchHighSchool(apiInstance) {
  try {
    const response = await apiInstance.get(`/LeaderBoard/search-high-school`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error fetching results");
  }
}

export async function fetchClubs(apiInstance) {
  try {
    const response = await apiInstance.get(`/public/club-list`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error fetching results");
  }
}

export async function fetchLeaderboardData(apiInstance, request) {
  try {
    const response = await apiInstance.post(`/LeaderBoard/enhanced`, request);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error fetching results");
  }
}
